/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * RapidWorks REST API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { ProblemDetails, RaptorJobTypeDto, RaptorJobTypeInputDto } from '.././model';

import { axiosInstance } from '../../axios-instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getApiV3JobTypes = (options?: SecondParameter<typeof axiosInstance>, signal?: AbortSignal) => {
  return axiosInstance<RaptorJobTypeDto[]>({ url: `/api/v3/job-types`, method: 'GET', signal }, options);
};

export const getGetApiV3JobTypesQueryKey = () => {
  return [`/api/v3/job-types`] as const;
};

export const getGetApiV3JobTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3JobTypes>>,
  TError = ProblemDetails | void
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypes>>, TError, TData>>;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3JobTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3JobTypes>>> = ({ signal }) => getApiV3JobTypes(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypes>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiV3JobTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV3JobTypes>>>;
export type GetApiV3JobTypesQueryError = ProblemDetails | void;

export function useGetApiV3JobTypes<TData = Awaited<ReturnType<typeof getApiV3JobTypes>>, TError = ProblemDetails | void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiV3JobTypes>>, TError, Awaited<ReturnType<typeof getApiV3JobTypes>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3JobTypes<TData = Awaited<ReturnType<typeof getApiV3JobTypes>>, TError = ProblemDetails | void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getApiV3JobTypes>>, TError, Awaited<ReturnType<typeof getApiV3JobTypes>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3JobTypes<TData = Awaited<ReturnType<typeof getApiV3JobTypes>>, TError = ProblemDetails | void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypes>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiV3JobTypes<TData = Awaited<ReturnType<typeof getApiV3JobTypes>>, TError = ProblemDetails | void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypes>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3JobTypesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiV3JobTypes = (
  raptorJobTypeInputDto: RaptorJobTypeInputDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RaptorJobTypeDto>(
    { url: `/api/v3/job-types`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: raptorJobTypeInputDto, signal },
    options
  );
};

export const getPostApiV3JobTypesMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiV3JobTypes>>, TError, { data: RaptorJobTypeInputDto }, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiV3JobTypes>>, TError, { data: RaptorJobTypeInputDto }, TContext> => {
  const mutationKey = ['postApiV3JobTypes'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV3JobTypes>>, { data: RaptorJobTypeInputDto }> = (props) => {
    const { data } = props ?? {};

    return postApiV3JobTypes(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV3JobTypesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV3JobTypes>>>;
export type PostApiV3JobTypesMutationBody = RaptorJobTypeInputDto;
export type PostApiV3JobTypesMutationError = ProblemDetails;

export const usePostApiV3JobTypes = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiV3JobTypes>>, TError, { data: RaptorJobTypeInputDto }, TContext>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiV3JobTypes>>, TError, { data: RaptorJobTypeInputDto }, TContext> => {
  const mutationOptions = getPostApiV3JobTypesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiV3JobTypesId = (id: number, options?: SecondParameter<typeof axiosInstance>, signal?: AbortSignal) => {
  return axiosInstance<RaptorJobTypeDto>({ url: `/api/v3/job-types/${id}`, method: 'GET', signal }, options);
};

export const getGetApiV3JobTypesIdQueryKey = (id?: number) => {
  return [`/api/v3/job-types/${id}`] as const;
};

export const getGetApiV3JobTypesIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError = ProblemDetails>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3JobTypesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3JobTypesId>>> = ({ signal }) =>
    getApiV3JobTypesId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3JobTypesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3JobTypesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV3JobTypesId>>>;
export type GetApiV3JobTypesIdQueryError = ProblemDetails;

export function useGetApiV3JobTypesId<TData = Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError = ProblemDetails>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError, Awaited<ReturnType<typeof getApiV3JobTypesId>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3JobTypesId<TData = Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError = ProblemDetails>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError, Awaited<ReturnType<typeof getApiV3JobTypesId>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3JobTypesId<TData = Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError = ProblemDetails>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiV3JobTypesId<TData = Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError = ProblemDetails>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3JobTypesId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3JobTypesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiV3JobTypesId = (
  id: number,
  raptorJobTypeInputDto: RaptorJobTypeInputDto,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<RaptorJobTypeDto>(
    { url: `/api/v3/job-types/${id}`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: raptorJobTypeInputDto },
    options
  );
};

export const getPutApiV3JobTypesIdMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiV3JobTypesId>>,
    TError,
    { id: number; data: RaptorJobTypeInputDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiV3JobTypesId>>, TError, { id: number; data: RaptorJobTypeInputDto }, TContext> => {
  const mutationKey = ['putApiV3JobTypesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV3JobTypesId>>, { id: number; data: RaptorJobTypeInputDto }> = (
    props
  ) => {
    const { id, data } = props ?? {};

    return putApiV3JobTypesId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiV3JobTypesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV3JobTypesId>>>;
export type PutApiV3JobTypesIdMutationBody = RaptorJobTypeInputDto;
export type PutApiV3JobTypesIdMutationError = ProblemDetails;

export const usePutApiV3JobTypesId = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiV3JobTypesId>>,
      TError,
      { id: number; data: RaptorJobTypeInputDto },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiV3JobTypesId>>, TError, { id: number; data: RaptorJobTypeInputDto }, TContext> => {
  const mutationOptions = getPutApiV3JobTypesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiV3JobTypesId = (id: number, options?: SecondParameter<typeof axiosInstance>) => {
  return axiosInstance<void>({ url: `/api/v3/job-types/${id}`, method: 'DELETE' }, options);
};

export const getDeleteApiV3JobTypesIdMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteApiV3JobTypesId>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV3JobTypesId>>, TError, { id: number }, TContext> => {
  const mutationKey = ['deleteApiV3JobTypesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV3JobTypesId>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return deleteApiV3JobTypesId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiV3JobTypesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV3JobTypesId>>>;

export type DeleteApiV3JobTypesIdMutationError = ProblemDetails;

export const useDeleteApiV3JobTypesId = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteApiV3JobTypesId>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteApiV3JobTypesId>>, TError, { id: number }, TContext> => {
  const mutationOptions = getDeleteApiV3JobTypesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
